<template>
  <el-dialog
      title="选择打印类型"
      :visible.sync="dialogVisible"
      width="30%"
      @close="handleClose">
    <div>
      <el-form>
        <el-form-item label="打印类型">
          <el-select v-model="selectedType" placeholder="请选择打印类型" style="width: 100%">
            <el-option label="标准样式发货单" :value="0"/>
            <el-option label="无公司抬头发货单" :value="1"/>
            <el-option label="客户物料送货单" :value="3"/>
            <el-option label="恒强送货单" :value="4"/>
            <el-option label="终端客户送货单" :value="5"/>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "PrintTypeDialog",
    props: {
      // 控制弹窗显示
      visible: {
        type: Boolean,
        default: false,
      },
      // 默认选中的打印类型
      defaultType: {
        type: [Number, null],
        default: null,
      },
      // 选择的数据列表
      selection: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        selectedType: null,
      };
    },
    computed: {
      dialogVisible: {
        get() {
          return this.visible;
        },
        set(val) {
          this.$emit("update:visible", val);
        },
      },
    },
    watch: {
      visible(newVal) {
        if (newVal) {
          // 弹窗打开时初始化选中类型
          this.selectedType = this.defaultType;
        }
      },
    },
    methods: {
      // 关闭弹窗
      handleClose() {
        this.dialogVisible = false;
        this.$emit("close");
      },
      // 确认选择
      handleConfirm() {
        if (this.selectedType === null || this.selectedType === undefined) {
          this.$message.error("请选择打印类型");
          return;
        }

        // 检查是否有类型不一致的情况
        const hasDiffType = this.selection.some(item => item.printType !== this.selectedType);
        
        if (!hasDiffType) {
          // 如果选择的类型与原始类型一致，直接确认
          this.handlePrintTypeConfirm();
        } else {
          // 如果类型不一致，显示确认提示
          this.$confirm("原单据类型与你所选的类型有不一致，是否继续打印？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            // 用户确认继续打印
            this.handlePrintTypeConfirm();
          }).catch(() => {
            // 用户取消，不做任何操作
          });
        }
      },
      // 确认打印
      handlePrintTypeConfirm() {
        let printUrl = this.selectedType === 0 ? "/deliveryCompanyNotePrint" : "/deliveryNotePrint";
        switch (this.selectedType) {
          case 0:
            printUrl = "/deliveryCompanyNotePrint";
            break;
          case 3:
            printUrl = "/deliveryCustomerNotePrint";
            break;
          case 4:
            printUrl = "/deliveryCustomerHengQiangPrint";
            break;
          case 5:
            printUrl = "/finalDeliveryNotePrint";
            break;
          default:
            printUrl = "/deliveryNotePrint";
            break;
        }
        const routeUrl = this.$router.resolve({
          path: printUrl,
          query: {
            params: JSON.stringify(this.selection),
          },
        });
        window.open(routeUrl.href, "_blank");
        this.handleClose();
      },
    },
  };
</script>

<style scoped>
</style>
